import React from 'react'
import TimeMarkers from './TimeMarkers'
import SlotLayers from './SlotLayers'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

const Slots = () => (
  <PerfectScrollbar>
    <div className='calendarRow slots'>
      <TimeMarkers />
      <SlotLayers />
    </div>
  </PerfectScrollbar>
)

export default Slots
